module.exports = __webpack_public_path__ + "img/2_Dicks_Screen_L_2_L.6a04cec5.jpg";